import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();

  return (
    <footer className="ft-blue">
      <div className="ft-wrap">
        <div className="ft-top">

          {/* BRAND */}
          <section className="ft-brand">
            <div className="ft-logo">
              {webinfo.logowhite ? (
                <Link to="/" className="ft-logoLink" aria-label={`${webinfo.name || "Virtue Digi"} — home`}>
                  <img
                    src={webinfo.logowhite}
                    alt=""
                    loading="lazy"
                    decoding="async"
                    fetchPriority="low"
                  />
                </Link>
              ) : (
                <h2 className="ft-brand-text">
                  {webinfo.name || "virtuedigihost.com"}
                </h2>
              )}
            </div>

            <p className="ft-desc">
              Virtue Digi at virtuedigihost.com: shared, WordPress, and VPS hosting
              for modern sites—with DNS, SSL, backups, and migration help when you
              need a steady hand.
            </p>

            <div className="ft-tags">
              <span>NVMe-ready tiers</span>
              <span>SSL &amp; backups</span>
              <span>24/7 support</span>
              <span>Migration desk</span>
            </div>

            <form
              className="ft-news"
              onSubmit={(e) => {
                e.preventDefault();
                const email = e.target.email.value;
                window.location.href = `mailto:${webinfo.email}?subject=Subscribe&body=Add ${email}`;
              }}
            >
              <input
                name="email"
                type="email"
                placeholder="you@company.com"
                required
              />
              <button type="submit" className="ft-btn">
                Subscribe
              </button>
            </form>
          </section>

          {/* SERVICES */}
          <nav className="ft-col">
            <h4>Hosting</h4>
            <ul>
              <li><a href="/services">All products</a></li>
              <li><a href="/services/shared-hosting">Shared hosting</a></li>
              <li><a href="/services/wordpress-hosting">WordPress</a></li>
              <li><a href="/services/vps-hosting">VPS & cloud</a></li>
              <li><a href="/process">How it works</a></li>
            </ul>
          </nav>

          {/* COMPANY */}
          <nav className="ft-col">
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/our-strategies">Why us</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/services">Plans</a></li>
            </ul>
          </nav>

          {/* CONTACT */}
          <section className="ft-contact">
            <h4>Contact</h4>
            <div className="ft-card">
              <div className="ft-row">
                <span className="ft-k">EMAIL</span>
                <a className="ft-v" href={`mailto:${webinfo.email}`}>
                  {webinfo.email || "contact@virtuedigihost.com"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">PHONE</span>
                <a className="ft-v" href={`tel:${webinfo.phonecall}`}>
                  {webinfo.phone || "+91 80000 00000"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">HOURS</span>
                <span className="ft-v">
                  {webinfo.hours || "Mon–Fri · 9am–6pm US"}
                </span>
              </div>

              <div className="ft-social">
                <a href={webinfo.linkedin || "#"}>in</a>
                <a href={webinfo.twitter || "#"}>X</a>
                <a href={webinfo.instagram || "#"}>IG</a>
              </div>
            </div>
          </section>

        </div>

        {/* BOTTOM */}
        <div className="ft-bottom">
          <p>© {year} {webinfo.name || "virtuedigihost.com"}. All rights reserved.</p>
          <div className="ft-legal">
            <a href="/terms-and-condition">Terms</a>
            <a href="/privacy-policy">Privacy</a>
            <a href="/disclaimer">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
